import { defineEvent } from "@visioni/a3s-analytics";
import type { CameraScope } from "@src/features/cameras/analytics";
import type { RequestErrorType } from "@src/services/api/error-type";

export function windowMinutes(start: Date, end: Date): number {
  return Math.round((end.getTime() - start.getTime()) / 60_000);
}

type RequestProps = CameraScope & { window_minutes: number };
export const ClipCompilationRequested = defineEvent<RequestProps>("Clip Compilation Requested");
export const ClipCompilationRequestFailed = defineEvent<RequestProps & { error_type: RequestErrorType }>(
  "Clip Compilation Request Failed",
);

type CompilationProps = CameraScope & { compilation_id: string };
export const ClipCompilationWatched = defineEvent<CompilationProps>("Clip Compilation Watched");
export const ClipCompilationDownloaded = defineEvent<CompilationProps>("Clip Compilation Downloaded");
export const ClipCompilationCancelled = defineEvent<CompilationProps>("Clip Compilation Cancelled");
export const ClipCompilationCancelFailed = defineEvent<CompilationProps & { error_type: RequestErrorType }>(
  "Clip Compilation Cancel Failed",
);
